<template>
  <div class="flex flex-col">
    <Button
      type="button"
      title="Center map"
      icon="CenterIcon"
      iconsize="32px"
      class="h-8 w-8 mb-1 focus-a"
      data-gtm-map-center-btn
      @click.native="$emit('mapCenter')"
    />
    <Button
      type="button"
      title="Zoom map in"
      icon="PlusIcon"
      iconsize="16px"
      class="flex-c bg-accent-1 h-8 w-8 mb-1 focus-b"
      :class="{ 'opacity-50': isMaxZoom }"
      :disabled="isMaxZoom"
      data-gtm-map-zoom-in-btn
      @click.native="$emit('mapZoomIn')"
    />
    <Button
      type="button"
      title="Zoom map out"
      icon="MinusIcon"
      iconsize="16px"
      class="flex-c bg-accent-1 h-8 w-8 mb-2 focus-b"
      :class="{ 'opacity-50': isMinZoom }"
      :disabled="isMinZoom"
      data-gtm-map-zoom-out-btn
      @click.native="$emit('mapZoomOut')"
    />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Button from '@/components/buttons/Button.vue'

export default {
  name: 'BtnsMap',

  components: {
    Button
  },

  props: {
    currentZoom: {
      type: Number,
      default: 3
    }
  },

  computed: {
    ...mapState(['touch', 'mobile', 'phone']),
    ...mapGetters([]),

    isMaxZoom() {
      return this.mobile ? this.currentZoom === 4 : this.currentZoom === 6
    },

    isMinZoom() {
      return this.currentZoom === 2
    }
  }
}
</script>
